import { queryOptions } from "@tanstack/react-query";
import { api } from "./api";

export const sessionQuery = () =>
  queryOptions({
    queryKey: ["session"],
    queryFn: api.me,
    staleTime: 60_000,
    retry: false
  });

export const catalogQuery = () =>
  queryOptions({
    queryKey: ["catalog"],
    queryFn: api.catalog,
    staleTime: 60_000,
    retry: false
  });

export const taskQuery = (id: string) =>
  queryOptions({
    queryKey: ["tasks", id],
    queryFn: () => api.getTask(id),
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === "completed" || status === "failed" || status === "timed_out" ? false : 10_000;
    }
  });
